import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios"

export interface LogStripeErrorRequest extends Partial<AxiosRequestConfig> {
  params: {
    bookingNo: string
    stripeError: string
  }
}
export interface LogStripeErrorResponse extends AxiosResponse {
  data: unknown
}

export function logStripeErrorApi(
  { params }: LogStripeErrorRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: params,
    method: "post",
    url: "/booking/log-stripe-error",
  }) as Promise<LogStripeErrorResponse>
}
